import Swiper, { A11y, Autoplay, EffectFade, Mousewheel, Navigation, Pagination, Scrollbar } from 'swiper';
Swiper.use([Mousewheel, Navigation, A11y, EffectFade, Autoplay, Pagination, Scrollbar]);
document.addEventListener('DOMContentLoaded', (event) => {
    const sliders = document.querySelectorAll('[data-ff-slider]');
    if (sliders.length > 0) {
        [...sliders].forEach((sliderItem) => {
            const speed = Number(sliderItem.dataset.ffSliderSpeed) * 1000;
            const options = {
                loop: true,
                navigation: {
                    nextEl: '.fifty-fifty-slider__slide--prev',
                    prevEl: '.fifty-fifty-slider__slide--next',
                },
                autoplay: {
                    disableOnInteraction: false,
                },
                slidesPerView: 1,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
                speed,
            };
            const swiper = new Swiper(sliderItem, options);
        });
    }
});
